<template>
  <div class="inline-flex flex-col items-center justify-center gap-4 text-center">
    <img alt="" src="@/assets/images/robot.svg" />
    <div class="inline-flex flex-col gap-1">
      <h3 class="text-heading-2 text-black-1 leading-5!">
        One day AI will build and launch this prompt
      </h3>
      <p class="text-body text-grey-1 mb-0">
        In the meantime, make sure the prompt is active or try a different date range
      </p>
    </div>
  </div>
</template>
